import DOMPurify from "dompurify";
export var cleanHtml = function cleanHtml(dirty, ALLOWED_TAGS) {
  var sanitized = DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ALLOWED_TAGS,
    FORBID_ATTR: ["style"]
  });
  var escapeMap = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&nbsp;": "",
    /* eslint-disable */
    "&#039;": "'"
    /* eslint-enable */
  };

  return sanitized.replace(/&amp;|&lt;|&gt;|&quot;|&#039;|&nbsp;/gi, function (m) {
    return typeof escapeMap[m] !== "string" ? m : escapeMap[m];
  });
};